import { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'

class ContentPanel extends Component {
  
  state = {
    template: this.props.skeleton,
    errorTemplate: this.props.errorTemplate
  };
  
  componentDidMount() {
    this.fetchData();
  }
  
  fetchData = async () => {
    try {
      const response = await fetch(this.props.templateUrl);

      if (response.ok) {
        const htmlContent = await response.text();

        this.setState({
          template: ReactHtmlParser(htmlContent)
        });
      } else {
        this.setState({
          template: this.props.errorTemplate
        })
      }
    } catch (e) {
      this.setState({
        template: this.props.errorTemplate
      })
    }
  };
  
  render() {
    return (this.state.template)
  }
}

export default withRouter(ContentPanel);

ContentPanel.propTypes = {
  skeleton: PropTypes.element,
  errorTemplate: PropTypes.element,
  templateUrl: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/ContentPanel/ContentPanel.js